import { PurchaseProtectionContent } from './components/PurchaseProtectionContent/PurchaseProtectionContent';
import { PurchaseProtectionCoverage } from './components/PurchaseProtectionCoverage/PurchaseProtectionCoverage';
import { PurchaseProtectionHero } from './components/PurchaseProtectionHero/PurchaseProtectionHero';
import { PurchaseProtectionPageMeta } from './components/PurchaseProtectionPageMeta/PurchaseProtectionPageMeta';
import { PurchaseProtectionTrust } from './components/PurchaseProtectionTrust/PurchaseProtectionTrust';

const PurchaseProtectionPage = () => {
    return (
        <div>
            <PurchaseProtectionPageMeta />
            <PurchaseProtectionHero />
            <PurchaseProtectionTrust />
            <PurchaseProtectionContent />
            <PurchaseProtectionCoverage />
        </div>
    );
};

export default PurchaseProtectionPage;
